import styled from "styled-components"
import theme from 'common/theme'

export const LinePointCircle = styled.circle`

    &:not(.is-hovered) {
        // fill: ${theme.colors.neg};
    }
    
    stroke-width: 1;
    r: 2.25;


`